import { MENU_CATALOG, menuAccessKeys } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

import { NAV } from './NAV';
import { usePermissions } from '../../lib/auth/usePermissions';

const ACCESS_BY_MENU = new Map(MENU_CATALOG.map((m) => [m.menuKey, m]));

function canSeeMenu(menuKey: string, can: (k: string) => boolean): boolean {
  const menu = ACCESS_BY_MENU.get(menuKey);
  if (!menu) return true; // not in catalog → always visible (dashboard, ledger, reports, consol)
  if (menu.readKeys.length === 0) return true; // write-only menu → always visible (server still enforces actions)
  return menuAccessKeys(menu).some((k) => can(k)); // read-tier menu → gate on access
}

export interface SidebarProps {
  active: string;
  onSelect: (id: string) => void;
}

export function Sidebar({ active, onSelect }: SidebarProps) {
  const { can } = usePermissions();
  return (
    <div className="app-sidebar">
      {NAV.map((group) => (
        <div key={group.section}>
          <div className="sb-section">{group.section}</div>
          {group.items
            .filter((item) => canSeeMenu(item.id, can))
            .map((item) => (
              <div
                key={item.id}
                className={`sb-item ${active === item.id ? 'active' : ''}`}
                onClick={() => onSelect(item.id)}
              >
                <Icon name={item.icon} size={16} className="sb-icon" />
                <span>{item.label}</span>
                {item.badge && <span className="sb-badge">{item.badge}</span>}
              </div>
            ))}
        </div>
      ))}
      <div
        style={{
          padding: '20px 14px 0',
          fontSize: 14,
          color: 'var(--text-faint)',
          borderTop: '1px solid var(--border)',
          marginTop: 12,
        }}
      >
        <div style={{ marginBottom: 4, fontWeight: 500, color: '#3f3f46' }}>ระบบสุขภาพ</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
          <span>ฐานข้อมูล</span>
          <span style={{ color: 'var(--positive)' }}>● ปกติ</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
          <span>Sync ล่าสุด</span>
          <span>2 นาทีที่แล้ว</span>
        </div>
      </div>
    </div>
  );
}
